import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
import type { VideosListFilter, VideosListSorter } from '../../../models';
import { useVideosInfiniteQuery } from '../../../queries';
import { VideoListEmptyState } from '../video-list-empty-state';

type P = {
  filter?: VideosListFilter;
  getPathToVideoDetail: (id: string) => string;
  sort?: VideosListSorter;
};

const VideoListContent = ({ filter, getPathToVideoDetail, sort }: P) => {
  const { isDebouncing, value: search } = useDebounce(filter?.search);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useVideosInfiniteQuery({
    filter: { search, type: filter?.type },
    pagination: { pageSize: 12 },
    sort,
  });

  const videos = data?.pages.flat().flatMap((videoPaginated) => videoPaginated.data);

  const hasFilteredValues = Boolean(search) || Boolean(filter?.type);

  return (
    <EntityList
      empty={<VideoListEmptyState isFiltered={hasFilteredValues} />}
      entities={videos?.map((video) => ({
        data: video,
        type: 'Video',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToVideoDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isDebouncing || isLoading}
    />
  );
};

export default VideoListContent;
